import * as translator from '../../../../utils/translator';

interface WhyChooseUsSectionProps {
  language: string;
  country: string;
}

export function WhyChooseUsSection({ language, country }: WhyChooseUsSectionProps) {
  const assetBasePath = (window as any).clientConfig?.assetBasePath || 'https://images.doktorabc.com/redesign_2025';
  const locale = `${language.toLowerCase()}-${country.toUpperCase()}`;
  
  const getPhoneImageUrl = (isMobile: boolean, format: 'png' | 'webp' = 'png') => {
    const suffix = isMobile ? '-mobile' : '';
    const folderName = `${locale}${suffix}`;
    return `${assetBasePath}/general/cms-phone/${folderName}/${folderName}.${format}`;
  };

  const getCategoriesNumber = () => {
    return country?.toLowerCase() === 'de' ? '40' : '36';
  };

  return (
    <div 
      className="mx-auto relative overflow-hidden rounded-[30px] md:w-[90%] min-h-[260px] mt-4 w-[95%]"
      style={{
        border: '8px solid white',
        boxShadow: '0 -10.917px 23.471px 0 #fff, 0 15.01px 30.566px 0 rgba(206,208,216,.41)',
        background: 'linear-gradient(40deg, #d9efde -29.29%, #f8f8f8 82.35%)'
      }}
    >
      <div className="flex items-start">
        <div className="flex flex-col flex-1 gap-[14px] p-[24px] z-[1]">
          <span 
            className="font-poppins text-[#1f2937] text-[16px] font-semibold italic"
            style={{ fontSize: 'clamp(16px, calc(22/519*100vw), 22px)' }}
          >
            {translator.translate(language, 'layout', 'menu/why_us')}
          </span>
          <div className="flex flex-col gap-[10px]">
            <div 
              className="items-center w-fit gap-[8px] inline-flex linear-background-color-primary rounded-[19.104px] text-white"
              style={{ padding: 'clamp(3px, calc(4/519*100vw), 4px) clamp(12px, calc(18/519*100vw), 18px)' }}
            >
              <span className="font-poppins font-semibold" style={{ fontSize: 'clamp(22px, calc(31/519*100vw), 31px)' }}>1M+</span>
              <span className="font-assistant" style={{ fontSize: 'clamp(14px, calc(19/519*100vw), 19px)' }}>
                {translator.translate(language, 'layout', 'menu/usp/clients')}
              </span>
            </div>
            <div 
              className="items-center w-fit gap-[8px] inline-flex linear-background-color-primary rounded-[19.104px] text-white"
              style={{ padding: 'clamp(3px, calc(4/519*100vw), 4px) clamp(12px, calc(18/519*100vw), 18px)' }}
            >
              <span className="font-poppins font-semibold" style={{ fontSize: 'clamp(22px, calc(31/519*100vw), 31px)' }}>{getCategoriesNumber()}+</span>
              <span className="font-assistant" style={{ fontSize: 'clamp(14px, calc(19/519*100vw), 19px)' }}>
                {translator.translate(language, 'layout', 'menu/usp/categories')}
              </span>
            </div>
            <div 
              className="items-center w-fit gap-[8px] inline-flex linear-background-color-primary rounded-[19.104px] text-white"
              style={{ padding: 'clamp(3px, calc(4/519*100vw), 4px) clamp(12px, calc(18/519*100vw), 18px)' }}
            >
              <span className="font-poppins font-semibold" style={{ fontSize: 'clamp(22px, calc(31/519*100vw), 31px)' }}>4M+</span>
              <span className="font-assistant" style={{ fontSize: 'clamp(14px, calc(19/519*100vw), 19px)' }}>
                {translator.translate(language, 'layout', 'menu/usp/orders')}
              </span>
            </div>
            <div 
              className="items-center w-fit gap-[8px] inline-flex linear-background-color-primary rounded-[19.104px] text-white"
              style={{ padding: 'clamp(3px, calc(4/519*100vw), 4px) clamp(12px, calc(18/519*100vw), 18px)' }}
            >
              <span className="font-poppins font-semibold" style={{ fontSize: 'clamp(22px, calc(31/519*100vw), 31px)' }}>8+</span>
              <span className="font-assistant" style={{ fontSize: 'clamp(14px, calc(19/519*100vw), 19px)' }}>
                {translator.translate(language, 'layout', 'menu/usp/years_trust')}
              </span>
            </div>
          </div>
        </div>
        <div className="flex items-end absolute bottom-0 right-0 top-0 z-[2]">
          <picture className="h-full md:hidden">
            <source srcSet={getPhoneImageUrl(true, 'webp')} type="image/webp" />
            <img 
              src={getPhoneImageUrl(true, 'png')} 
              alt=""
              className="h-full w-auto"
              style={{ transition: 'opacity .4s ease-in-out' }}
              loading="lazy"
              decoding="async"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          </picture>
          <picture className="h-full hidden md:block">
            <source srcSet={getPhoneImageUrl(false, 'webp')} type="image/webp" />
            <img 
              src={getPhoneImageUrl(false, 'png')} 
              alt=""
              className="h-full w-auto"
              style={{ transition: 'opacity .4s ease-in-out' }}
              loading="lazy"
              decoding="async"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          </picture>
        </div>
      </div>
    </div>
  );
}
